import React, { Fragment } from "react";
import { FormGroup, Checkbox, Input, Icon } from "xsolla-uikit";
import { PAinfoCollapsible } from "../uikit2";
export function PAconnectorChatSlackInner({ connected = false, header = "Xsolla Slack bot", children = `Sync users with MailChimp`, handleSubmitButton = () => {
  void 0;
}, }) {
  // let requiredFields = [
  //   apikey,
  //   list
  // ]
  let [apikey, setApikey] = React.useState(null);
  let [list, setList] = React.useState();
  let [submitActive, setSubmitActive] = React.useState(false);
  let [fetching, setFetching] = React.useState(false);
  let apiInput = React.createRef();
  let fetchTime = null;
  React.useEffect(() => {
    let active = true;
    // [apikey, list].forEach((oneReq, ind)=> {
    //   if (!oneReq) active = false;
    // })
    if (!apikey || (apikey && apikey.length !== 16))
      active = false;
    // if (!list) active = false;
    if (apikey && apikey.length === 16 && !fetching) {
      setFetching(true);
      fetchTime = setTimeout(() => {
        setFetching(false);
      }, 800);
    }
    console.log("fetching = ", fetching);
    setSubmitActive(active);
    return () => {
      if (fetchTime)
        clearTimeout(fetchTime);
    };
  }, [apikey]);
  React.useEffect(() => {
    // apiInput.current.focus();
    console.log("apiInput = ", apiInput);
  }, []);
  return (<Fragment>
    <FormGroup indentation="lg">
      <PAinfoCollapsible title="How to set up Slack with Xsolla">
        <p>
          To enable Xsolla chat integration, first create a custom bot in
            Slack. Then, add the bot to the desired channels or private groups.{" "}
        </p>

        <ul className="manual-box__content__list-numbers">
          <li>
            Go to{" "}
            <a href="https://admin.mailchimp.com/account/api-key-popup" target="_blank">
              Slack Bots App{" "}
              </a>
              page.
            </li>

          <li>Click “Add to Slack”.</li>

          <li>
            Choose a username for your bot (e.g., "Xsolla-bot") and click "Add
            bot integration".
            </li>

          <li>Copy the API token for your bot.</li>
        </ul>
      </PAinfoCollapsible>
    </FormGroup>

    <FormGroup label="Slack API token" indentation="md">
      <Input input={{
        ref: apiInput,
        name: "small",
        value: apikey,
        onChange: (e: SyntheticInputEvent<HTMLInputElement>) => setApikey(e.target.value),
      }} disabled={apikey && apikey.length === 16 ? true : false} offset="right" extra={!!apikey &&
        apikey.length === 16 && (<Icon name="circle-remove-mini" hoverable={true} onClick={(e) => {
          setApikey(null);
          setList(null);
          e.target.focused = true;
        }} />)} size="md" inline={true} style={{ width: "100%" }} placeholder="Enter Slack API token" />
    </FormGroup>

    <FormGroup label="Xsolla channels">
      <div className="xsui-tree-select__entries" style={{
        padding: "12px 16px",
        background: "rgba(21, 10, 10, .02)",
      }}>
        <FormGroup>
          <Checkbox name={`check_Customersupportchannel`} disabled={!submitActive} label="Customer support channel" input={{
            value: true,
            onChange: () => void 0,
          }} />
          <div className="xsui-form-group__label">
            Discuss any payment-related issues directly with our team. You can
            also ask our team any questions you have or address any questions
            from your users.
            </div>
        </FormGroup>

        <FormGroup>
          <Checkbox name={`check_Technicalintegrationchannel`} label="Technical integration channel" disabled={!submitActive} input={{
            value: true,
            onChange: () => void 0,
          }} />
          <div className="xsui-form-group__label">
            Ask our specialists any integration or product-related questions.
            </div>
        </FormGroup>

        <FormGroup>
          <Checkbox name={`check_Specialprojectsintegrationchannel`} label="Special projects integration channel" disabled={!submitActive} input={{
            value: true,
            onChange: () => void 0,
          }} />
          <div className="xsui-form-group__label">
            Join this channel if you're looking for a customized solution or
            want to enable special features.
            </div>
        </FormGroup>

        <FormGroup>
          <Checkbox name={`check_Legalquestionschannel`} label="Legal questions channel" disabled={!submitActive} input={{
            value: true,
            onChange: () => void 0,
          }} />
          <div className="xsui-form-group__label">
            Ask our specialists any legal questions you may have.
            </div>
        </FormGroup>

        <FormGroup>
          <Checkbox name={`check_Antifraudandconversionchannel`} label="Anti-fraud and conversion channel" disabled={!submitActive} input={{
            value: true,
            onChange: () => void 0,
          }} />
          <div className="xsui-form-group__label">
            Request conversion reports and discuss special anti-fraud
            parameters.
            </div>
        </FormGroup>

        <FormGroup>
          <Checkbox name={`check_Newschannel`} label="News channel" disabled={!submitActive} input={{
            value: true,
            onChange: () => void 0,
          }} />
          <div className="xsui-form-group__label">
            Get Xsolla updates, news, release announcements and improvements
            to help you grow your business.
            </div>
        </FormGroup>
      </div>
    </FormGroup>


  </Fragment>);
}
